<template>
    <div>
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="add">新增</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column prop="id" label="序号" sortable width="180">
            </el-table-column>
            <el-table-column prop="name" label="工作类别" sortable width="180">
            </el-table-column>
            <el-table-column prop="priority" label="排序" sortable width="180">
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="mini" @click="edit(scope.row)">修改</el-button>
                        <el-button size="mini" @click="del(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>


        <el-dialog :title="form.id ? '修改' : '新增'" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="名称">
                    <el-input v-model="form.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.priority" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetDialogForm">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../api'
const {
    search,
} = api
export default {
    name: "kwywords",
    data() {
        return {
            loading: true,
            tableData: [],
            dialogFormVisible: false,
            form: {
                id: '',
                name: '',
                priority: 0,
            },
            isSubmiting: false,
        };
    },
    watch: {
        pageNum() {
            this.fetch()
        }
    },
    methods: {
        async fetch() {
            this.loading = true;
            let res = await search.list();
            this.tableData = res.data.data;
            this.loading = false;
        },
        add() {
            this.dialogFormVisible = true;
            this.form.id = '';
            this.form.name = '';
            this.form.priority = 0;
        },
        edit(word) {
            this.form = word;
            this.dialogFormVisible = true
        },
        async submit() {
            if (this.isSubmiting) return false;
            this.isSubmiting = true;
            let action = 'add';
            let args = {
                name: this.form.name,
                priority: this.form.priority
            };
            if (this.form.id) {
                action = 'update';
                args.id = this.form.id;
            }

            let {
                data: {
                    code
                }
            } = await search[action](args)
            if (code === 200) {
                if (this.form.id != '') {
                    this.$message.success('修改成功');
                } else {
                    this.$message.success('添加成功');
                }
                this.fetch();
                this.resetDialogForm();
            }
            this.isSubmiting = false;
        },
        async del(word) {

            this.$confirm(`是否删除热门搜索词 ${word.name}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '再想想',
                type: 'warning'
            }).then(async() => {
                if (this.isSubmiting) return false;
                this.isSubmiting = true;
                let {
                    data: {
                        code
                    }
                } = await search.delete({
                    id: word.id
                })
                if (code === 200) {
                    this.$message.success('删除成功');
                    this.fetch();
                }
                this.isSubmiting = false;
            }).catch((e) => {
                this.isSubmiting = false;
                if (e === 'cancel') {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: '操作失败'
                    });
                }
            });
        },
        resetDialogForm() {
            this.form.id = '';
            this.form.name = '';
            this.form.priority = 0;
            this.dialogFormVisible = false;
        },
    },
    mounted() {
        this.fetch();
    }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/search/keywords.vue